import React from 'react';

function MemberAddressLayout({
	filteredAddress,
	setRadioSelection,
	handleShippingDefault,
}) {
	return (
		<div
			className='dmlp__member-checkout__address__info text-dark-medium cursor-pointer'
			onClick={() => {
				setRadioSelection(filteredAddress.addressId);
				handleShippingDefault(filteredAddress.addressId);
			}}
		>
			{filteredAddress?.salutation} {filteredAddress?.firstName}{' '}
			{filteredAddress?.lastName} <br />
			{filteredAddress?.companyName
				? 'Company: ' + filteredAddress?.companyName
				: null}
			{filteredAddress?.companyName && <br />}
			{filteredAddress?.address1} {filteredAddress?.address2} <br />
			{filteredAddress?.city
				.toLowerCase()
				.replace(/\b[a-z]/g, function (letter) {
					return letter.toUpperCase();
				})}{' '}
			{filteredAddress?.state} {filteredAddress?.postalCode} <br />
			Phone: {filteredAddress?.dayPhoneNumber}
		</div>
	);
}

export default MemberAddressLayout;
